module.exports = __webpack_public_path__ + "img/treeplant1_7-8-2021.593e7837.jpg";